import { DefaultConfigValues } from "../utils/constants";

export const getServiceUrls = () => {
  if (process.env.NODE_ENV === "production") {
    return {
      FEE_SERVICE: `{REACT_APP_API_URL_PLACEHOLDER}feeservice`,
      USER_SERVICE: `{REACT_APP_API_URL_PLACEHOLDER}userservice`,
      TRIP_SERVICE: `{REACT_APP_API_URL_PLACEHOLDER}tripservice`,
      INVOICE_SERVICE: `{REACT_APP_API_URL_PLACEHOLDER}invoiceservice`,
      MESSAGING_SERVICE: `{REACT_APP_API_URL_PLACEHOLDER}messagingservice`,
      CONFIG_SERVICE: `{REACT_APP_API_URL_PLACEHOLDER}configservice`,
      REACT_APP_KEYCLOAK_URL: `REACT_APP_KEYCLOAK_URL_PLACEHOLDER`,
      REACT_APP_KEYCLOAK_REALM: `REACT_APP_KEYCLOAK_REALM_PLACEHOLDER`,
      REACT_APP_KEYCLOAK_CLIENT_ID: `REACT_APP_KEYCLOAK_CLIENT_ID_PLACEHOLDER`,
      REACT_APP_PLUGNPAY_URL: `REACT_APP_PLUGNPAY_URL_PLACEHOLDER`,
      REACT_APP_PLUGNPAY_GATEWAY_ACCOUNT: `REACT_APP_PLUGNPAY_GATEWAY_ACCOUNT_PLACEHOLDER`,
      REACT_APP_PROFILE_ENV: `REACT_APP_PROFILE_ENV_PLACEHOLDER`,
      REACT_APP_VERSION: `REACT_APP_VERSION_PLACEHOLDER`,
      REACT_APP_SENTRY_DSN: `REACT_APP_SENTRY_DSN_PLACEHOLDER`,
    };
  }

  // For local development
  return {
    FEE_SERVICE: `${DefaultConfigValues.REACT_APP_API_URL}feeservice`,
    USER_SERVICE: `${DefaultConfigValues.REACT_APP_API_URL}userservice`,
    TRIP_SERVICE: `${DefaultConfigValues.REACT_APP_API_URL}tripservice`,
    INVOICE_SERVICE: `${DefaultConfigValues.REACT_APP_API_URL}invoiceservice`,
    MESSAGING_SERVICE: `${DefaultConfigValues.REACT_APP_API_URL}messagingservice`,
    REACT_APP_KEYCLOAK_URL: DefaultConfigValues.REACT_APP_KEYCLOAK_URL,
    REACT_APP_KEYCLOAK_REALM: DefaultConfigValues.REACT_APP_KEYCLOAK_REALM,
    REACT_APP_KEYCLOAK_CLIENT_ID:
      DefaultConfigValues.REACT_APP_KEYCLOAK_CLIENT_ID,
    REACT_APP_PLUGNPAY_URL: DefaultConfigValues.REACT_APP_PLUGNPAY_URL,
    REACT_APP_PLUGNPAY_GATEWAY_ACCOUNT:
      DefaultConfigValues.REACT_APP_PLUGNPAY_GATEWAY_ACCOUNT,
    CONFIG_SERVICE: `${DefaultConfigValues.REACT_APP_API_URL}configservice`,
    REACT_APP_PROFILE_ENV: DefaultConfigValues.REACT_APP_PROFILE_ENV,
    REACT_APP_VERSION: DefaultConfigValues.REACT_APP_VERSION,
    REACT_APP_SENTRY_DSN: DefaultConfigValues.REACT_APP_SENTRY_DSN,
  };
};
